'use client';

import { LicenseInfo } from '@mui/x-license';

LicenseInfo.setLicenseKey(
    '4a45038121b786cca3f43da22d69e025Tz0xMzAyODcsRT0xODE0MTQwNzk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1pbml0aWFsLEtWPTI='
);

export default function MuiXLicense() {
    return null;
}
